export function toastOption(p_option) {
    let v_autoClose = 3000;
    if(p_option.message==="" || p_option.message===undefined || p_option.message.length===0){
        if(p_option.type==="error"){
            p_option.message = "Ocurrió un desconocido.";
            v_autoClose = false;
        }
        else if(p_option.type==="error401"){
            p_option.type="error";
            p_option.message = "Su sesión ha caducado o ud no tiene privilegios para realizar esta operación. Por favor, inicie sesión nuevamente.";
            v_autoClose = false;
        }
        else if(p_option.type==="success"){
            p_option.message = "La operación se realizó exitosamente.";
        }
    }
    // return authorization header with jwt token  
    let option = {};
    if(p_option.type==="close"){ 
        option = {
            render: ".",
            isLoading: false, 
            autoClose:1
        };
    }
    else{        
        option = { 
            position: "top-right",
            render: p_option.message, 
            type: p_option.type, 
            isLoading: false, 
            autoClose: v_autoClose,
            closeOnClick:true,
            closeButton: true,
            theme:"colored"
        };
    }
    
    return option;
}
